import { en } from '../translations/en';
import { bn } from '../translations/bn';

const translations = {
  en,
  bn
};

// Get translation function
export const t = (key, language = 'en') => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return value || key;
};

// Get all translations for a section
export const getTranslations = (section, language = 'en') => {
  return translations[language]?.[section] || {};
};

export default translations;

